import { render, staticRenderFns } from "./batch-list.vue?vue&type=template&id=d9f14b2a&"
import script from "./batch-list.vue?vue&type=script&lang=ts&"
export * from "./batch-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports